import React, { useState } from "react"

import Form from "./Form"
import Tabs from "../Tabs"

import { FormModule } from "../../models/modules"

interface Props extends FormModule {
  pageContext: any
}

const defaultProps = {}

export const Forms: React.FC<Props> = props => {
  const [working, setWorking] = useState(false)
  const workingHandler = (state: boolean) => {
    setWorking(state)
  }
  if (!props.forms || props.forms.length === 0) return null
  if (props.forms.length === 1)
    return (
      <>
        <Form
          {...props.forms[0]}
          workingHandler={workingHandler}
          pageContext={props.pageContext}
        />{" "}
        {working && (
          <div className="form__working">
            <div className="lds-dual-ring"></div>
          </div>
        )}
      </>
    )

  if (props.forms.length > 1) {
    const tabs = props.forms.map(form => {
      return {
        heading: form.tab_heading || "",
        content: (
          <Form
            {...form}
            workingHandler={workingHandler}
            pageContext={props.pageContext}
          />
        ),
      }
    })

    return (
      <section>
        <Tabs tabs={tabs} />

        {working && (
          <div className="form__working">
            <div className="lds-dual-ring"></div>
          </div>
        )}
      </section>
    )
  }

  return null
}

Forms.defaultProps = defaultProps

export default Forms
